<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="check-box">
              <label
                class="checkbox-s"
                v-for="(item, index) in contents"
                :key="item.templateNo"
                name="온라인 장례식장 조문글 템플릿"
              >
                <input type="radio" name="radio" :value="item" v-model="state.object" />
                <span class="check-txt">{{ item.content }}</span>
              </label>
            </div>
          </div>
          <BasicButton modal-btn @leftEvent="close" @rightEvent="fnFetch" left-text="닫기" right-text="선택" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { COMMENT_LIST, FUNERAL_EMOTICON_LIST } from '@/common/constants/ConstCode';
import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { fnShowIsAppModal, isApp, isEmpty } from '@/common/utils/Util';
import { modalList, show, showDoneModal, showLoginModal, showTextModal } from '@/common/utils/ModalState';
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import { useStore } from 'vuex';
import { purchaseCall } from '@/common/utils/module/NativeRequest';
import router from '@/router';

const store = useStore();

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, defaultValue, errorText } = props.data;

const userData = store.getters['user/getUserData'];

const isInput = ref(false);

const contents = computed(() => props.data?.contents);
const state = reactive({
  object: ''
});

onMounted(async () => {
  state.object = defaultValue ?? COMMENT_LIST?.value[0] ?? '';
});

onUnmounted(() => {
  isInput.value = false;
});

// watch(
//   () => state.object,
//   value => {
//     if (value === '직접입력' && !userData.canSuperChat) {
//       showDoneModal('해당 기능은 슈퍼챗 구매 후 이용 가능합니다.', '구매', '취소', fnBuySuperChat);
//
//       state.object = '';
//       isInput.value = false;
//       return false;
//     }
//   }
// );

const fnFetch = () => {
  // 직접입력 X
  if (state.object.content !== '직접입력') {
    if (!isEmpty(state.object)) {
      fnCallBack(state.object);
      close();
      return;
    }

    showTextModal(errorText || '원하는 항목을 선택해 주세요.', '확인');
    return false;
  }

  // 직접입력 선택 && 슈퍼챗 구매한 유저
  if (state.object.content === '직접입력' && userData.canSuperChat) {
    isInput.value = true;

    fnCallBack({ isInput: true });
    close();
    return;
  } else {
    if (!userData?.userNo) {
      showLoginModal(() => {
        router.push('/signin');
      });
      return;
    }

    if (!userData.canSuperChat) {
      showDoneModal('해당 기능은 슈퍼챗 구매 후 이용 가능합니다.', '구매', '취소', () => {
        if (isApp()) {
          store.commit('layout/setProductBuyMove', true);
          router.push('/more/item/buy');
        } else {
          fnShowIsAppModal();
          return false;
        }
      });
      return false;
    }

    if (isEmpty(state.textInput)) {
      showTextModal('조문글을 입력해 주세요.', '확인');
      return false;
    }

    return;
  }

  if (state.object.content !== '직접입력') {
    if (fnCallBack) fnCallBack(state.object);
    close();
  }
};

const close = () => {
  setTimeout(() => {
    emits('close');
  }, 300);
};

const fnBuySuperChat = () => {
  if (isApp()) {
    purchaseCall();
  } else {
    showTextModal('지원하지 않는 OS입니다.', '확인');
    return false;
  }
};
</script>
<style scoped></style>
